module.exports = "/lucky-balls/img/bonus_yellow/ball_holder.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/ball_holder.png
// module id = 944
// module chunks = 0